<nb-card class="footer-card">
  <p>Created by <a href="https://corvus-it.com/">corvus-it.com</a> <small>({{version}})</small></p>
</nb-card>
